export const environment = {
    production: false,
    keycloak: {
        enabled: true,
        url: 'https://auth.staging.wewiins.fr/',
        realm: 'wewiins-bo',
        clientId: 'back-office'
    },
    api: {
        url: 'https://staging.wewiins.fr/api'
    }
};